import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import { SnackbarProvider } from 'notistack'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './index.css'
import reportWebVitals from './reportWebVitals'
import router from './router'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    iconVariant={{
      success: <CheckCircleIcon sx={{ color: '#DBFFF6', backgroundColor: '#00BD94', borderRadius: '50%', marginRight: '12px' }} />,
      error: <ErrorIcon sx={{ color: '#FFE2E8', backgroundColor: '#FF3232', borderRadius: '50%', marginRight: '12px' }} />,
    }}>
    <RouterProvider router={router} />
  </SnackbarProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
